"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_ORDER_LINE_QUANTITY = void 0;
/**
 * Upper bound for the quantity of a single order line.
 *
 * A retail order line is measured in plates for one store for one week, so four
 * digits is far above anything real; the cap is there to stop a slipped keypress
 * (an extra digit, a pasted value) from reaching the MRP as a production order.
 * It lives in the shared domain because the server enforces it and the client's
 * quantity control has to agree with the same number — one bound, one place.
 */
exports.MAX_ORDER_LINE_QUANTITY = 9999;
//# sourceMappingURL=order-line-limits.js.map